import styled from 'styled-components';
import React, { useCallback, useState } from 'react';
import { cssColorValue, cssSpacing } from '@spotify-internal/encore-web';
import { CarouselNav } from '../../CarouselNav';
import { EmblaCarousel } from '../EmblaCarousel';
import { VideoCarouselSlide } from '../EmblaCarousel/VideoSlide';
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  background-color: ${cssColorValue('backgroundBase')};
  color: ${cssColorValue('textBase')};
  height: 100%;
  gap: ${cssSpacing('looser')};
`;
export const CompactVideoCarousel = ({ videos, useControlNumbers = true, className, }) => {
    const [videoIdx, setVideoIdx] = useState(0);
    const scrollPrev = useCallback(() => {
        setVideoIdx(videoIdx - 1 + videos.length);
    }, [videos.length, videoIdx, setVideoIdx]);
    const scrollNext = useCallback(() => {
        setVideoIdx((videoIdx + 1) % videos.length);
    }, [videos.length, videoIdx, setVideoIdx]);
    return (React.createElement(Wrapper, { className: className },
        React.createElement(EmblaCarousel, { slides: videos, numberOfSlidesToShow: 1, videoIdx: videoIdx, setVideoIdx: n => {
                setVideoIdx((n + videos.length) % videos.length);
            }, scrollNext: scrollNext, scrollPrev: scrollPrev, renderSlide: ({ vid, idx, affordanceState, hasInteracted }) => (React.createElement(VideoCarouselSlide, { video: vid, affordanceState: affordanceState, isCurrent: idx === videoIdx, hasInteracted: hasInteracted })) }),
        React.createElement(CarouselNav, { handlePrev: () => scrollPrev(), handleNext: () => scrollNext(), allowLooping: true, index: videoIdx + 1, total: videos.length, useControlNumbers: useControlNumbers })));
};
